import React from 'react'
import EditColumnMenu from 'components/spreadsheet/components/menu/views/editcolumn'
import { NewColumn } from './useNewColumn'

interface NewColumnMenuProps {
  id: string
  newColumn: NewColumn
}

// The Edit column panel for a column being added, where its + button or menu item opened it.
const NewColumnMenu: React.FC<NewColumnMenuProps> = ({ id, newColumn }) => {
  const { menuState, setMenuState, draft, processing, submit, close } = newColumn
  if (!menuState.open || !draft) return null
  // While the column is being created, Esc and a press outside leave the panel open: it closes once it's made.
  const holdWhileCreating: typeof setMenuState = (next) => {
    if (processing) return
    setMenuState(next)
  }

  return (
    // Clicks inside it reach the + button or menu item that owns it through the portal's React tree, which
    // would open it again.
    <div onClick={(event) => event.stopPropagation()}>
      <EditColumnMenu
        id={id}
        menuState={menuState}
        setMenuState={holdWhileCreating}
        newColumn={{ draft, onCreate: submit, onCancel: close, creating: processing }}
      />
    </div>
  )
}

export default NewColumnMenu
